import React, { useEffect, useState } from 'react';
import AppFooter from '../../components/AppFooter/AppFooter';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faCalendar } from '@fortawesome/free-regular-svg-icons';
import { faMapMarkerAlt, faIndustry } from '@fortawesome/free-solid-svg-icons';

//Header Data

import headerLogo from '../../assets/desall_logo.png';
import { contestNavPages } from '../../mockdata/navPages';

//Footer Data
import footerImg from '../../assets/footer_placeholder_transparent.png';
import TimeLineWLF from '../../components/TimeLine/TimeLineWLF';
import ActionButton, { MultiActionButtonsWrapper } from '../../components/ActionButton/ActionButton';

import { getCoCreationContestStats, getFooterMenu, getHeaderMenu, getContestAccessDenied } from '../../store/Selectors';
import { useStoreState } from 'pullstate';
import DslStore, { setContestAccessDenied } from '../../store/DslStore';
import { finalSlicedString, finalString } from '../../helpers/utils';
import axiosHelper from '../../helpers/axiosHelper';

import { Contest } from '../../global';
import { useNavigate, useParams } from 'react-router-dom';
import BriefWLF from './BriefWLF';
import useSWR from 'swr';
import { useAuth } from '../../context/AuthContext';
import InspirationsWLF from './InspirationsWLF';
import AwardsWLF from './AwardsWLF';
import { ContestPageNavigation } from '../../components/PageNavigation/ContestPageNavigation';
import UploadContestWLF from './UploadContestWLF';
import GalleryWLF from './GalleryWLF';
import AppHeaderWLF from '../../components/AppHeader/AppHeaderWLF';
import PopUpSendMessage from '../../components/PopUp/PopUpSendMessage/PopUpSendMessage';
import ContestStatsWLF from '../../components/Community/ContestStats/ContestStatsWLF';
import { userUrlForUser } from '../../helpers/navigationUtils';
import { dateStringForContest } from '../../helpers/contestUtilities';
import LogoAnimation from '../../components/LogoAnimation/LogoAnimation';
import { useBanner } from '../../context/BannerContext';
import axios from 'axios';

const ContestSkeletonWLF: React.FC = () => {
  const { createAndAddBannerMessage } = useBanner();
  const footerMenu = useStoreState(DslStore, getFooterMenu);
  const headerMenu = useStoreState(DslStore, getHeaderMenu);
  const [popupMessage, setPopupMessage] = useState(false);
  const [contest, setContest] = useState<Contest>();
  const { loggedUser, showLoginPopup } = useAuth();
  const [canGoahead, setCanGoAhead] = useState(true);
  const cocreationstats = useStoreState(DslStore, getCoCreationContestStats);
  const contestAccessDenied = useStoreState(DslStore, getContestAccessDenied);
  const { nameForURL } = useParams();
  const { pageName } = useParams();
  const { designName } = useParams();
  const [subPage, setSubPage] = useState('Brief');
  const [pageTitle, setPageTitle] = useState('Brief');
  const [messageBanner, setMessageBanner] = useState(0);
  const [privateGalleryMessage, setPrivateGalleryMessage] = useState(false);
  const path = window.location.pathname;
  const redirect = useNavigate();
  const { data, isLoading, mutate } = useSWR('contestname|' + nameForURL, axiosHelper.contestsFetcher);
  const [dateString, setDateString] = useState<string>('');

  const refreshContest = async () => {
    mutate();
  };

  useEffect(() => {
    console.log('USEFFECT PAGE NAME', pageName);
    var pn = pageName;

    if (!pageName) {
      pn = 'Brief';
    }
    const which = contestNavPages.find((item) => item.path === '/' + pn);
    if (which) {
      setPageTitle(which.text);
    } else {
      setPageTitle(contestNavPages[0].text);
      setSubPage(contestNavPages[0].path);
    }
    console.log(which);
    if (pn) {
      setSubPage(pn);
    }
  }, [pageName]);

  useEffect(() => {
    console.log('USEFFECT DATA', data);
    if (data) {
      console.log('GOT DATA');
      console.log(data);
      setContest(data);
      setDateString(dateStringForContest(data));
    }
  }, [data]);

  useEffect(() => {
    console.log('USEFFECT CONTEST');
    console.log(contest);
    if (contest) {
      if (contest.needsNDA || contest.needsAccessCode) {
        setCanGoAhead(false);
      }
      if (contest.isPrivate) {
        createAndAddBannerMessage('This contest has a private gallery. You can join it but you can’t see its entries', 'warning', 'priv' + contest.id, true);
      }
    }
  }, [contest]);

  const goToDetail = async (nameForURL: string) => {
    console.log(contest);
    redirect(userUrlForUser(nameForURL, true));
  };
  const invokeLogin = () => {
    console.log('PRESSED INVOKE LOGIN');
    showLoginPopup();
  };
  if (isLoading) {
    return (
      <div className="bg-light-gray">
        <AppHeaderWLF
          links={headerMenu}
          bgColor={contest?.bannerColor ? contest.bannerColor : '#C3DE72'}
          logoImg={headerLogo}
          bgImage={contest?.bannerImage}
          alpha={0}
          breadcrumbs={`Home/Contest`}
          pageTitle={nameForURL}
          hideSearch={true}
        />
        <LogoAnimation />
        <AppFooter links={footerMenu} bgColor="#304053" logoImg={headerLogo} bgImage={footerImg} />
      </div>
    );
  }
  return (
    <div className="bg-light-gray">
      <AppHeaderWLF
        links={headerMenu}
        bgColor={contest?.bannerColor ? contest.bannerColor : '#C3DE72'}
        logoImg={headerLogo}
        bgImage={contest?.bannerImage}
        alpha={0}
        breadcrumbs={`Home/Contest`}
        pageTitle={contest?.name || nameForURL}
        hideSearch={true}
      />
      {contest && (
        <>
          <ContestPageNavigation contest={contest} pageName={pageName ?? 'Brief'} />
          {/* <MessagesContainer>
            <MessageComponent
              visible={privateGalleryMessage}
              message="This contest has a private gallery. You can join it but you can’t see its entries"
              level="warning"
              closeCallback={() => setPrivateGalleryMessage(false)}
            />
            <MessageComponent visible={contestAccessDenied} message="Access Denied!" level="error" closeCallback={() => setContestAccessDenied(false)} />
            {messageBanner === 1 && <MessageComponent visible={privateGalleryMessage} message="Message sent!" level="success" closeCallback={() => setMessageBanner(0)} />}
            {messageBanner === 2 && (
              <MessageComponent visible={privateGalleryMessage} message="The mailserver is busy, please try again!" level="error" closeCallback={() => setMessageBanner(0)} />
            )}
          </MessagesContainer> */}

          <main className={`container mb-5 overflow-hidden`}>
            {!designName && (
              <>
                <div className="row px-4  px-sm-1  ">
                  <div className="col-12 col-md-3  text-center mx-3 mx-sm-0  d-flex align-items-end justify-content-sm-center justify-content-md-start ">
                    <div className="position-relative ">
                      <img style={{ width: '270px', height: '270px' }} className="img-fluid rounded mt-5 " src={contest?.image} alt="Placeholder" />
                      {contest?.isPrivate ||
                        (contest?.hideGalleryTab && (
                          <MultiActionButtonsWrapper position="bottom-left" rounded>
                            <ActionButton label="Private gallery" icon="private" />
                          </MultiActionButtonsWrapper>
                        ))}
                    </div>
                  </div>
                  <div className="col-12 col-md-9 px-3 pt-5">
                    <div className="row">
                      <div className="info-main mb-5 px-3 px-sm-2  col-12">
                        <h1 className="sub-title-brief  color-dark">{contest.name}</h1>
                        <div className="text-16 color-dark">{finalString(contest?.categoryName)}</div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-12 px-3 px-sm-2 col-md-3">
                        <div className="info">
                          <div className="d-flex justify-content-start mb-3" style={{ height: '20px', overflow: 'hidden' }}>
                            <div className="d-flex flex-column justify-content-center">
                              <FontAwesomeIcon icon={faIndustry as IconProp} className=" text color-blue me-2" />
                            </div>
                            <div className="text color-blue" style={{ cursor: 'pointer' }} onClick={() => goToDetail(contest.usernameForURL)}>
                              {contest.username != null ? finalSlicedString(contest.username) : finalString(contest.linkToClient)}
                            </div>
                          </div>
                          <div className="d-flex  justify-content-start mb-3">
                            <div className="d-flex flex-column justify-content-center">
                              <FontAwesomeIcon icon={faMapMarkerAlt as IconProp} className=" text color-blue me-3" />
                            </div>
                            <div className="text">{contest?.city + ', ' + contest?.countryName}</div>
                          </div>
                          <div className="d-flex  justify-content-start">
                            <div className="d-flex flex-column justify-content-center">
                              <FontAwesomeIcon icon={faCalendar as IconProp} className=" text color-blue me-3" />
                            </div>
                            <div className="text ">{dateString}</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-9  mt-5 mt-md-0 ">
                        {contest.contestType !== 'Co-creation' ? (
                          <ContestStatsWLF entries={contest.entries ?? 0} inspirations={contest.inspirationCount ?? 0} awards={contest.prizes} votes={contest.sumVotesCount ?? 0} />
                        ) : (
                          <ContestStatsWLF
                            entries={cocreationstats?.entries}
                            inspirations={cocreationstats?.inspirations}
                            awards={cocreationstats?.awards}
                            votes={cocreationstats?.votes}
                          />
                        )}
                      </div>
                      <div className=" d-none  d-md-flex flex-row align-items-end justify-content-center ">
                        <div className="container px-1 ps-sm-2 mx-0 pe-lg-1">
                          <TimeLineWLF contest={contest} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {popupMessage && (
                  <PopUpSendMessage
                    setMessageNumber={(message) => (setMessageBanner(message), setPopupMessage(false))}
                    popup={popupMessage}
                    close={() => setPopupMessage(false)}
                    contestId={contest.id}
                    recipient={'Desall'}
                  />
                )}
              </>
            )}
            {/* Body ====================================================================== */}
            {contest && (
              <>
                {subPage === 'Brief' && (
                  <BriefWLF refreshContest={refreshContest} loggedUser={loggedUser} contest={contest} setPopupMessage={setPopupMessage} loginCallback={invokeLogin} />
                )}
                {subPage.includes('Inspirations') && !path.includes('new') && !path.includes('edit') && <InspirationsWLF contest={contest} loginCallback={invokeLogin} />}
                {subPage.includes('Awards') && (
                  <>
                    <AwardsWLF contest={contest} setPopupMessage={setPopupMessage} />
                  </>
                )}

                {subPage.includes('Gallery') && <GalleryWLF contest={contest} designName={designName} loggedUser={loggedUser} loginCallback={invokeLogin} />}
                {subPage.includes('Upload') && <UploadContestWLF contest={contest} setPopupMessage={setPopupMessage} />}
              </>
            )}
          </main>
          <AppFooter links={footerMenu} bgColor="#304053" logoImg={headerLogo} bgImage={footerImg} />
        </>
      )}
    </div>
  );
};

export default ContestSkeletonWLF;
